import { View } from "react-native";
import { usePartnerInvitation } from "@src/packages/patients/hooks/usePartnerInvite";
import { useYouScreen } from "../YouScreenContext";
import InviteFriend from "./InviteFriend";
import PartnerCard from "./PartnerCard";

/**
 * The two optional journey prompts share a compact row before the profile
 * sections. Once an invite is pending or connected, the richer partner status
 * card takes the full width instead.
 */
export default function ConnectionPrompts() {
  const { patient } = useYouScreen();
  const { data: invitation } = usePartnerInvitation();

  const hasPartner = !!patient?.partnerConnected;
  const hasPendingPartnerInvite = invitation?.status === "pending";

  if (hasPartner || hasPendingPartnerInvite) {
    return <PartnerCard />;
  }

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "stretch",
        gap: 12,
      }}
    >
      <PartnerCard compact />
      <InviteFriend compact />
    </View>
  );
}
